import { defaultIconColor } from 'assets/constants';
import { SVGComponentPropsType } from 'assets/types';
import { CURRENCY_DEFAULT_SIZE } from './constants';

const defaultSize = CURRENCY_DEFAULT_SIZE;

export default ({
  height = defaultSize,
  width = defaultSize,
  color = defaultIconColor,
  opacity = 1,
  outlined = false,
  viewBox = `0 0 ${defaultSize} ${defaultSize}`,
  ...props
}: SVGComponentPropsType) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...props}>
    <g opacity={opacity} stroke={color} strokeWidth="2">
      {outlined && <circle cx="12" cy="12" r="11" />}
      <path
        d="M16 9h-6c-.55228 0-1 .44772-1 1v1c0 .55228.44772 1 1 1h4c.55228 0 1 .44772 1 1v1c0 .55228-.44772 1-1 1H8"
        strokeLinejoin="round"
      />
      <path d="M12 8V6m0 12v-2" />
    </g>
  </svg>
);
